<app-registro [idformulario]="idFormulario" [idencuesta]="idEncuesta" [idsujeto]="idRegistro"  ></app-registro>
